import styled from 'styled-components'
import { Paper } from '@material-ui/core'
import { theme, colors } from '../../../theme/Global'

export const CustomFullPageWrapper = styled.div`
    background-color: ${theme.colors.blueBackground};
    bottom: 0;
    height: 100%;
    left: 0;
    overflow-y: auto;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    display: flex;
    flex: 1;
`

export const CustomPaper = styled(Paper)`
  background: ${colors.white};
  margin: 5vh auto 0 auto;
  max-width: 587px;
  padding: 59px 89px;
  text-align: center;
  width: 90%;
`

export const PasswordCriteria = styled.ul`
  list-style: none;
  padding-inline-start: 0;
`
